module.exports = __webpack_public_path__ + "static/media/texture (34).6431080f.jpg";